import styled from 'styled-components';
export const List = styled.ul `
  list-style-type: disc;
  margin-left: 20px;
`;
